/*
 * Desktop header dropdowns work by hover and by click:
 * - hover opens after a short intent delay and closes (with a fade) on leave;
 * - clicking the item pins the menu open until a second click, a click
 *   outside or Escape; after a click-close, hover waits for the pointer to
 *   leave before it can reopen the menu.
 * Keyboard keeps the native toggle. Touch devices and the mobile drawer keep
 * the default click behaviour.
 */
(function () {
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 220;
  var FADE_OUT = 160;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desktop = window.matchMedia('(min-width: 990px)');

  function hoverMode() {
    return canHover.matches && desktop.matches;
  }

  function init() {
    var menus = Array.prototype.slice.call(
      document.querySelectorAll('.header__inline-menu details[id^="Details-HeaderMenu-"]')
    );
    if (!menus.length) return;

    var states = menus.map(function (details) {
      return {
        details: details,
        summary: details.querySelector('summary'),
        pinned: false,
        suppressHover: false,
        openTimer: 0,
        closeTimer: 0,
        fadeTimer: 0
      };
    });

    function clearTimers(s) {
      clearTimeout(s.openTimer);
      clearTimeout(s.closeTimer);
      clearTimeout(s.fadeTimer);
    }

    function open(s) {
      clearTimers(s);
      s.details.classList.remove('smt-menu-closing');
      if (!s.details.hasAttribute('open')) s.details.setAttribute('open', '');
      s.summary.setAttribute('aria-expanded', 'true');
      states.forEach(function (other) {
        if (other !== s) close(other, true);
      });
    }

    function close(s, immediate) {
      clearTimers(s);
      s.pinned = false;
      if (!s.details.hasAttribute('open')) return;
      s.summary.setAttribute('aria-expanded', 'false');
      if (immediate) {
        s.details.classList.remove('smt-menu-closing');
        s.details.removeAttribute('open');
        return;
      }
      s.details.classList.add('smt-menu-closing');
      s.fadeTimer = setTimeout(function () {
        s.details.classList.remove('smt-menu-closing');
        s.details.removeAttribute('open');
      }, FADE_OUT);
    }

    states.forEach(function (s) {
      var details = s.details;

      details.addEventListener('mouseenter', function () {
        if (!hoverMode() || s.suppressHover) return;
        clearTimeout(s.closeTimer);
        clearTimeout(s.fadeTimer);
        if (details.hasAttribute('open')) {
          open(s);
          return;
        }
        s.openTimer = setTimeout(function () {
          open(s);
        }, OPEN_DELAY);
      });

      details.addEventListener('mouseleave', function () {
        if (!hoverMode()) return;
        s.suppressHover = false;
        clearTimeout(s.openTimer);
        if (s.pinned) return;
        s.closeTimer = setTimeout(function () {
          close(s);
        }, CLOSE_DELAY);
      });

      // Mouse click: pin a hover-opened menu, or close a pinned one.
      // Keyboard activation (detail === 0) keeps the native toggle.
      s.summary.addEventListener('click', function (event) {
        if (!hoverMode() || event.detail === 0) return;
        event.preventDefault();
        if (s.pinned) {
          close(s);
          s.suppressHover = true;
          return;
        }
        open(s);
        s.pinned = true;
      });

      details.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !details.hasAttribute('open')) return;
        close(s, true);
        s.summary.focus();
      });
    });

    // A click outside closes a pinned menu.
    document.addEventListener('click', function (event) {
      if (!hoverMode()) return;
      states.forEach(function (s) {
        if (s.pinned && !s.details.contains(event.target)) close(s, true);
      });
    });

    // Leaving hover mode (resize to tablet) resets any menu left open.
    function reset() {
      if (hoverMode()) return;
      states.forEach(function (s) {
        clearTimers(s);
        s.pinned = false;
        s.suppressHover = false;
        s.details.classList.remove('smt-menu-closing');
      });
    }
    if (desktop.addEventListener) desktop.addEventListener('change', reset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
